export const Tag = ({
  label,
  selected = false,
  shape = 'pill',        // 'pill' | 'rectangle'
  iconLeft = null,
  iconRight = null,
  badge = false,
  onClick,
}) => (
  <button
    type="button"
    className={[
      'tag',
      `tag--${shape}`,
      selected ? 'tag--selected' : '',
      badge ? 'tag--badge' : '',
    ].join(' ')}
    onClick={onClick}
  >
    {iconLeft && <span className="tag__icon tag__icon--left">{iconLeft}</span>}
    <span className="tag__label">{label}</span>
    {iconRight && <span className="tag__icon tag__icon--right">{iconRight}</span>}
    {badge && <span className="tag__badge" />}
  </button>
);

export default Tag;